<script>
  export let lightboxOpen;
</script>

<button
  on:click={() => {
    lightboxOpen = true;
  }}
  title="Bild vergrößern"
  class="group absolute right-0 top-0 z-30 hidden bg-theme-minor-200/80 p-3 text-black/80 hocus:opacity-100 md:block"
  type="button"
>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true" focusable="false" role="img" class="h-6 w-6 fill-current opacity-60 transition group-hocus:opacity-100">
    <path
      d="M500.3 443.7l-119.7-119.7c-15.03 22.3-34.26 41.54-56.57 56.57l119.7 119.7c15.62 15.62 40.95 15.63 56.57 .0003C515.9 484.7 515.9 459.3 500.3 443.7zM288 184H231.1V128c0-13.26-10.74-24-23.1-24S184 114.7 184 128v56H127.1C114.7 184 104 194.7 104 208s10.73 24 23.1 24H184V288c0 13.26 10.73 24 23.1 24c13.26 0 23.1-10.74 23.1-24V232h56C301.3 232 312 221.3 312 208S301.3 184 288 184z"
    />
    <path
      class="opacity-40"
      d="M208 0C93.13 0 0 93.13 0 208S93.13 416 208 416S416 322.9 416 208S322.9 0 208 0zM288 232H231.1V288c0 13.26-10.74 24-23.1 24C194.7 312 184 301.3 184 288V232H127.1C114.7 232 104 221.3 104 208s10.74-24 23.1-24H184V128c0-13.26 10.74-24 23.1-24S231.1 114.7 231.1 128v56h56C301.3 184 312 194.7 312 208S301.3 232 288 232z"
    />
  </svg>
</button>
